import { Flex, Loader } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import { type ReactElement, Suspense } from 'react';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

import { VoucherAndCertificateLayout } from '../../../FSD/shared/ui/layout/VoucherAndCertificateLayout';
import Vouchers from '../../../components/pages/my/vouchers/Vouchers';
import { CertificateWrapper } from '../../../components/pages/my/vouchers/template/CertificationOfVoucherTemplate';
import { DeferredComponent } from '../../../components/util/DeferredComponent';
import useBlockNonAdminAccess from '../../../hooks/useBlockNonAdminAccess';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await getCdnTranslationProps(locale, ['common'])),
  },
  revalidate: 60,
});

export default function MyVouchersPage() {
  useBlockNonAdminAccess();

  return (
    <Suspense
      fallback={
        <DeferredComponent>
          <Flex justify="center" align="center" w="100%" mih={369}>
            <Loader size="lg" />
          </Flex>
        </DeferredComponent>
      }
    >
      <Vouchers />
    </Suspense>
  );
}

function MyVouchersPageLayout({
  children,
  pathname,
}: {
  children: ReactElement;
  pathname: string;
}) {
  const { t } = useTranslation();
  return (
    <VoucherAndCertificateLayout
      pathname={pathname}
      title={t('메타.수강확인증.제목')}
      description={t('메타.수강확인증.설명')}
    >
      {children}
      <CertificateWrapper />
    </VoucherAndCertificateLayout>
  );
}

MyVouchersPage.getLayout = (page: ReactElement, pathname: string) => (
  <MyVouchersPageLayout pathname={pathname}>{page}</MyVouchersPageLayout>
);
